angular
  .module('clientDashboardApp.admin')
  .directive('falsyValidator', () => {
    return {
      require: 'ngModel',
      link(scope, el, attrs, ctrl) {
        ctrl.$validators.falsy = (modelValue, viewValue) => {
          return !modelValue
        }

      }
    }
  })
